$('.trading__copy-toggler').click(function () {
    const trigger = $(this).hasClass('active');

    $(this).toggleClass('active', !trigger);
    $(this).closest('.trading__tr').toggleClass('opened', !trigger);
})
